<app-breadcrumbs class="mb-3" [lastLabel]="(name ?? '')"></app-breadcrumbs>

<mat-card class="mat-elevation-z8 container-card">
    <mat-card-content class="mat-elevation-z8">
        <mat-tab-group (selectedTabChange)="onTabChanged($event)">

            <mat-tab label="Dati Generali Policy">
                <div class="form-container">
                    <form [formGroup]="formDataGeneral" (ngSubmit)="onSubmitGeneralData()" class="p-4 form--underline form-general">

                        <div class="form-section">
                            <div class="pair-grid">
                                <!-- Nome Policy (readonly) -->
                                <mat-form-field appearance="fill" class="readonly" subscriptSizing="dynamic">
                                    <mat-label>Nome Policy</mat-label>
                                    <input matInput type="text" formControlName="name" readonly aria-readonly="true" />
                                    <mat-icon matSuffix class="suffix-readonly" aria-hidden="true">lock</mat-icon>
                                </mat-form-field>

                                <!-- Descrizione (required) -->
                                <mat-form-field appearance="fill" subscriptSizing="dynamic">
                                    <mat-label>Descrizione</mat-label>
                                    <input matInput type="text" formControlName="description" required />
                                    <mat-error *ngIf="formDataGeneral.get('description')?.hasError('required')">
                                        Il campo è obbligatorio
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="actions">
                            <button type="submit" class="btn btn-primary save-button my-3" mat-raised-button matTooltip="Salva" aria-label="Salva" [disabled]="(formDataGeneral.invalid && formDataGeneral.touched) || isLoading || !canDoActions('BACKOFFICE_ADMIN')">
                        Salva
                      </button>
                        </div>

                        <app-loading [showLoading]="isLoading"></app-loading>
                    </form>
                </div>
            </mat-tab>

            <mat-tab label="Fields">
                <app-shared-table [dataSource]="dataSourceMeta" [displayedColumns]="['fieldName', 'textRegex', 'boost', 'actions']" [columnLabels]="{fieldName: 'Field', textRegex: 'Testo/Regex', boost: 'Boost'}" (openModal)="openDialog($event)" [length]="fieldTotalItems" [pageSize]="fieldPageSize" [pageIndex]="fieldPageIndex" (pageChanged)="onPageChanged($event)" [isLoading]="isLoading" [isSortable]="false"></app-shared-table>
            </mat-tab>

            <mat-tab label="Peso Data">
                <div class="form-container">
                    <form [formGroup]="formData" (ngSubmit)="onSubmit()" class="p-4 form--underline peso-data col-12">

                        <!-- Fattore di decadimento -->
                        <div class="form-section">
                            <h4>Fattore di decadimento</h4>
                            <div class="slider-grid">
                                <mat-form-field appearance="fill" subscriptSizing="dynamic">
                                    <mat-label>Imposta fattore (0–1)</mat-label>
                                    <input matInput type="number" step="0.01" min="0" max="1" [formControl]="decayFactorInput" required />

                                    <mat-error *ngIf="formData.get('decay')?.hasError('required')">Il campo è obbligatorio</mat-error>
                                    <mat-error *ngIf="formData.get('decay')?.hasError('min')">Il valore non può essere &lt; 0</mat-error>
                                    <mat-error *ngIf="formData.get('decay')?.hasError('max')">Il valore non può essere &gt; 1</mat-error>
                                </mat-form-field>

                                <div class="slider-wrap">
                                    <mat-slider min="0" max="1" step="0.01">
                                        <input matSliderThumb [formControl]="decayFactorSlider" />
                                    </mat-slider>
                                    <div class="slider-scale">
                                        <span>0</span><span>0.5</span><span>1</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Offset -->
                        <div class="form-section" formGroupName="offset">
                            <h4>Offset</h4>
                            <div class="pair-grid">
                                <mat-form-field appearance="fill">
                                    <mat-label>Quantità</mat-label>
                                    <input matInput type="number" formControlName="number" />
                                </mat-form-field>

                                <mat-form-field appearance="fill">
                                    <mat-label>Unità di tempo</mat-label>
                                    <mat-select formControlName="timeValue">
                                        <mat-option value="giorno">Giorno</mat-option>
                                        <mat-option value="mese">Mese</mat-option>
                                        <mat-option value="anno">Anno</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Scale -->
                        <div class="form-section" formGroupName="scale">
                            <h4>Scale</h4>
                            <div class="pair-grid">
                                <mat-form-field appearance="fill">
                                    <mat-label>Quantità</mat-label>
                                    <input matInput type="number" formControlName="number" />
                                </mat-form-field>

                                <mat-form-field appearance="fill">
                                    <mat-label>Unità di tempo</mat-label>
                                    <mat-select formControlName="timeValue">
                                        <mat-option value="giorno">Giorno</mat-option>
                                        <mat-option value="mese">Mese</mat-option>
                                        <mat-option value="anno">Anno</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="actions">
                            <button type="submit" class="btn btn-primary save-button" mat-raised-button matTooltip="Salva" aria-label="Salva" [disabled]="(formData.invalid && formData.touched) || isLoading || !canDoActions('BACKOFFICE_ADMIN')">
                        Salva
                      </button>
                        </div>

                        <!-- Loading -->
                        <app-loading [showLoading]="isLoading"></app-loading>
                    </form>
                </div>
            </mat-tab>


            <mat-tab label="Alias">
                <app-shared-table [dataSource]="dataSourceAlias" [displayedColumns]="['aliasName', 'boost', 'actions']" [columnLabels]="{aliasName: 'Alias', boost: 'Boost'}" (openModal)="openDialog($event)" [length]="aliasTotalItems" [pageSize]="aliasPageSize" [pageIndex]="aliasPageIndex" (pageChanged)="onPageChanged($event)" [isLoading]="isLoading" [isSortable]="false">
                </app-shared-table>
            </mat-tab>

        </mat-tab-group>
    </mat-card-content>
</mat-card>